module.exports = __webpack_public_path__ + "img/voucher_popup.e755ea60.png";